import FluxUtils from 'flux/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';
import UrlQuery from 'sharedreact/utils/UrlQuery';

import UsersConnection from 'workspaces/common/connections/UsersConnection';
import UsersStore from 'workspaces/common/stores/UsersStore';

import asFunctional from 'sharedreact/components/asFunctional';
import TokensActions from 'workspaces/launcher/actions/TokensActions';
import TokenDetailsTab from 'workspaces/launcher/components/admin/TokenDetailsTab';
import Token from 'workspaces/launcher/data/Token';
import TokensStore from 'workspaces/launcher/stores/TokensStore';
import { StaticContext } from 'react-router';
import LocationState from 'sharedreact/utils/LocationState';

type Props = RouteComponentProps<{}, StaticContext, LocationState> & {
  index: number,
  activeTab: number,
  action: string,
  userId: string,

  onGoBack?: () => void,
};

type State = ConstructorParameters<typeof TokenDetailsTab>[0];

function getStores () {
  return [
    SettingsStore,
    UsersStore,
    TokensStore
  ];
}

function handleGoBack (props: Props) {
  TokensActions.closeDetails();
  if (props.onGoBack != null) {
    props.onGoBack();
  } else {
    const search: {[key: string]: string} = UrlQuery.parse(props.location.search);
    if (search.fromurl) {
      const fromUrl: string = decodeURIComponent(search.fromurl);
      props.history.push(fromUrl);
    } else {
      props.history.push({pathname: '/admin', search: '?tab=managetokens', state: {}});
    }
  }
}

function handleCreate (userId: string, tags: string) {
  TokensActions.create(userId, tags, false);
}

function handleSave (userId: string, tags: string) {
  TokensActions.update(userId, tags);
}

function handleConfirmOverwrite (userId: string, tags: string) {
  TokensActions.create(userId, tags, true);
  TokensActions.setNeedsConfirm(false);
}

function handleCancelOverwrite () {
  TokensActions.setNeedsConfirm(false);
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  const token: Token | null = TokensStore.getItems().find((item) => (item != null && item.id === props.userId)) ?? null;

  return {
    index: props.index,
    activeTab: props.activeTab,
    action: props.action,
    userId: props.userId,
    token: token,
    language: SettingsStore.getLanguage(),
    showClipboardMsg: TokensStore.getShowClipboardMsg(),
    saveMsg: TokensStore.getSaveMsg(),
    onCreate: handleCreate,
    onSave: handleSave,
    onGoBack: () => handleGoBack(props),
    onCloseClipboardMsg: TokensActions.hideClipboardMsg,
    onGetUserSuggestions: UsersConnection.fetchSuggestions,
    needsConfirm: TokensStore.needsConfirm(),
    onConfirmOverwrite: handleConfirmOverwrite,
    onCancelOverwrite: handleCancelOverwrite
  };
}

export default withRouter(
  FluxUtils.Container.createFunctional(
    asFunctional(TokenDetailsTab),
    getStores,
    calculateState,
    { withProps: true }
  )
);
